'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _resources = require('redux/modules/resources');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const GETTING_READY = 0;
var FAMILY_ACTIVITIES = 0;
var MODULE_1 = 1;
var MODULE_2 = 2;
var MODULE_3 = 3;
var MODULE_4 = 4;
var GUIDE_BOOK = 5;
// const BOOSTER_MODULE = 'boostermodule';

var Resources = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, module: state.resources.module, item: state.resources.item, page: state.resources.page };
}, { changeResource: _resources.changeResource }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Resources, _Component);

  function Resources() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Resources);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Resources.__proto__ || (0, _getPrototypeOf2.default)(Resources)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      familyActivities: [{
        id: 0,
        title: 'Family fridge game',
        favi: 'fa fa-photo',
        component: _react2.default.createElement(_components.FamilyActivitiesRes1, null)
      }, {
        id: 1,
        title: '6-fun ways to play with vegetables',
        favi: 'fa fa-bar-chart-o',
        component: _react2.default.createElement(_components.FamilyActivitiesRes2, null)
      }],
      module1: [{
        id: 0,
        title: 'Putting the five food groups all together',
        favi: 'fa fa-photo',
        component: _react2.default.createElement(_components.Module1Res1, null)
      }, {
        id: 1,
        title: 'Vegetable providing diary',
        favi: 'fa fa-bar-chart-o',
        component: _react2.default.createElement(_components.Module1Res2, null)
      }],
      module2: [{
        id: 0,
        title: 'Making mealtimes positive',
        component: _react2.default.createElement(_components.Module2Res1, null)
      }, {
        id: 1,
        title: 'Creating a healthy home environment',
        component: _react2.default.createElement(_components.Module2Res2, null)
      }, {
        id: 2,
        title: 'Establishing rules',
        component: _react2.default.createElement(_components.Module2Res3, null)
      }, {
        id: 3,
        title: 'Dealing with change',
        component: _react2.default.createElement(_components.Module2Res4, null)
      }, {
        id: 4,
        title: 'Sample meal planner',
        component: _react2.default.createElement(_components.Module2Res5, null)
      }, {
        id: 5,
        title: 'Sample shopping list',
        component: _react2.default.createElement(_components.Module2Res6, null)
      }, {
        id: 6,
        title: 'Cost saving shopping tips',
        component: _react2.default.createElement(_components.Module2Res7, null)
      }, {
        id: 7,
        title: 'Ideas for healthy snacks',
        component: _react2.default.createElement(_components.Module2Res8, null)
      }, {
        id: 8,
        title: 'Seasonal guide to fruit and vegetables',
        component: _react2.default.createElement(_components.Module2Res9, null)
      }, {
        id: 9,
        title: 'Storing fruit and vegetables',
        component: _react2.default.createElement(_components.Module2Res10, null)
      }, {
        id: 10,
        title: 'Recipe Links',
        component: _react2.default.createElement(_components.Module2Res11, null)
      }],
      module3: [{
        id: 0,
        title: 'The P\'s and C\'s: a helpful framework',
        component: _react2.default.createElement(_components.Module3Res1, null)
      }, {
        id: 1,
        title: 'No vegies, please! Managing mealtime behaviour',
        component: _react2.default.createElement(_components.Module3Res2, null)
      }, {
        id: 2,
        title: 'Preparation strategies',
        component: _react2.default.createElement(_components.Module3Res3, null)
      }, {
        id: 3,
        title: 'Strategies best avoided',
        component: _react2.default.createElement(_components.Module3Res4, null)
      }, {
        id: 4,
        title: 'Providing praise',
        component: _react2.default.createElement(_components.Module3Res5, null)
      }, {
        id: 5,
        title: 'Dealing with misbehaviour',
        component: _react2.default.createElement(_components.Module3Res6, null)
      }, {
        id: 6,
        title: 'Time out principles',
        component: _react2.default.createElement(_components.Module3Res7, null)
      }, {
        id: 7,
        title: 'Time out tips',
        component: _react2.default.createElement(_components.Module3Res8, null)
      }],
      module4: [{
        id: 0,
        title: 'Summary of Reboot Kids Program',
        component: _react2.default.createElement(_components.Module4Res1, null)
      }, {
        id: 1,
        title: 'Shopping with children',
        component: _react2.default.createElement(_components.Module4Res2, null)
      }, {
        id: 2,
        title: 'Useful links',
        component: _react2.default.createElement(_components.Module4Res3, null)
      }],
      guidebook: [{
        id: 0,
        title: 'Reboot parent guidebook',
        favi: 'fa fa-photo',
        component: _react2.default.createElement(_components.GuidebookRes1, null)
      }]
    }, _this.handleResourceClick = function (module, item, event) {
      event.preventDefault();
      console.log('module', module);
      console.log('item', item);
      _this.props.changeResource(module, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  (0, _createClass3.default)(Resources, [{
    key: 'renderResourceGroup',


    /*
     * Render a resource group
     */
    value: function renderResourceGroup(moduleObject, thisModule) {
      var _this2 = this;

      var styles = require('./ResourcesLanding.scss');

      // Link to the module id's
      return _react2.default.createElement(
        'div',
        null,
        moduleObject.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: 'res' + index },
            _this2.props.module === thisModule && _this2.props.item === item.id && _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              item.title
            ),
            (_this2.props.module !== thisModule || _this2.props.item !== item.id) && _react2.default.createElement(
              _reactRouter.Link,
              { to: '', onClick: _this2.handleResourceClick.bind(_this2, thisModule, item.id), key: thisModule + '' + item.id },
              item.title
            ),
            _react2.default.createElement('br', null)
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          module1 = _state.module1,
          module2 = _state.module2,
          module3 = _state.module3,
          module4 = _state.module4,
          familyActivities = _state.familyActivities,
          guidebook = _state.guidebook;

      var styles = require('./ResourcesLanding.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: 'Resources' }),
        _react2.default.createElement(
          'div',
          { className: styles.resourcesPage },
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 3, sm: 3, xs: 3, className: styles.sidebar },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h1',
                null,
                'Resources'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'div',
                { className: styles.cardContent },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Family activities'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Creative strategies to help your child interact with vegetables and fruit at home'
                ),
                this.renderResourceGroup(familyActivities, FAMILY_ACTIVITIES)
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'div',
                { className: styles.cardContent },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Module 1'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Healthy eating habits'
                ),
                this.renderResourceGroup(module1, MODULE_1)
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'div',
                { className: styles.cardContent },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Module 2'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Home food environments'
                ),
                this.renderResourceGroup(module2, MODULE_2)
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'div',
                { className: styles.cardContent },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Module 3'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Encouraging vegetables'
                ),
                this.renderResourceGroup(module3, MODULE_3),
                _react2.default.createElement('h4', null),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Review and future planning'
                ),
                this.renderResourceGroup(module4, MODULE_4)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'div',
                { className: styles.cardContent },
                _react2.default.createElement(
                  'h3',
                  null,
                  'The Reboot-Kids parent guidebook'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'A PDF summary the Reboot-Kids program'
                ),
                this.renderResourceGroup(guidebook, GUIDE_BOOK)
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 })
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 3, sm: 3, xs: 3 },
            '\xA0'
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 9, sm: 9, xs: 9 },
            this.state.familyActivities.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'familyactivities' + index },
                _this3.props.module === FAMILY_ACTIVITIES && _this3.props.item === index && item.component
              );
            }),
            this.state.module1.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'mod1' + index },
                _this3.props.module === MODULE_1 && _this3.props.item === index && item.component
              );
            }),
            this.state.module2.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'mod2' + index },
                _this3.props.module === MODULE_2 && _this3.props.item === index && item.component
              );
            }),
            this.state.module3.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'mod3' + index },
                _this3.props.module === MODULE_3 && _this3.props.item === index && item.component
              );
            }),
            this.state.module4.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'mod4' + index },
                _this3.props.module === MODULE_4 && _this3.props.item === index && item.component
              );
            }),
            this.state.guidebook.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: 'guidebook' + index },
                _this3.props.module === GUIDE_BOOK && _this3.props.item === index && item.component
              );
            })
          )
        )
      );
    }
  }]);
  return Resources;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  module: _propTypes2.default.number,
  item: _propTypes2.default.number,
  page: _propTypes2.default.number,
  changeResource: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Resources;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResourcesLanding/ResourcesLanding.js
// module id = 1288
// module chunks = 0